import { TypographyOptions } from '@mui/material/styles/createTypography';

const TYPOGRAPHY_COLOR = '#2D0202';

export const typography: TypographyOptions = {
  fontFamily: 'Montserrat, sans-serif',
  htmlFontSize: 16,
  fontWeightLight: 400,
  fontWeightRegular: 600,
  fontWeightMedium: 700,
  fontWeightBold: 900,
  h1: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 900,
    fontSize: '2.5rem',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    paddingBottom: '0rem',
    marginTop: '0',
    color: TYPOGRAPHY_COLOR,
  },
  h2: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 600,
    fontSize: '1.7rem',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    paddingBottom: '0rem',
    marginTop: '0',
    color: TYPOGRAPHY_COLOR,
  },
  h3: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    paddingBottom: '0rem',
    marginTop: '0',
    color: TYPOGRAPHY_COLOR,
  },
  h4: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    fontSize: '1rem',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    paddingBottom: '0rem',
    marginTop: '0',
    color: TYPOGRAPHY_COLOR,
  },
  h5: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    fontSize: '0.875rem',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    paddingBottom: '0rem',
    marginTop: '0',
    color: TYPOGRAPHY_COLOR,
  },
  h6: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 700,
    fontSize: '0.75rem',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    paddingBottom: '0rem',
    marginTop: '0',
    color: TYPOGRAPHY_COLOR,
  },
  body1: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    paddingBottom: '0rem',
    marginTop: '0',
    color: TYPOGRAPHY_COLOR,
  },
  body2: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: 400,
    fontSize: '75%',
    lineHeight: 1.2,
    letterSpacing: '0.5px',
    paddingBottom: '0rem',
    marginTop: '0',
    color: TYPOGRAPHY_COLOR,
  },
  button: {
    fontFamily: 'Montserrat, sans-serif',
  },
};
